export const get_security_transition = `query get_security_transition($id: String!){
    get_security_transition(id: $id){
        transaction_code
        status
        from_account
        to_account
        amount
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        transfer_date
        fulfillment_date
    }
}`;
